/**
 * Environment and preview detection utilities
 */

export const isInIframe = (): boolean => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
};

export const isLovablePreview = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const hostname = window.location.hostname;
  const search = window.location.search;
  
  return (
    isInIframe() || // Preview loads inside an iframe
    hostname.includes('lovable.app') ||
    hostname.includes('lovable.dev') ||
    search.includes('__lovable_preview') ||
    search.includes('lovable')
  );
};

export const prefersReducedMotion = (): boolean => {
  if (typeof window === 'undefined') return false;
  return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
};
